<template>
  <component :is="el" :label="label" :prop="prop" :required="required">
    <div v-if="noForm">{{label}}&nbsp;</div>
    <el-switch
      v-model="formData"
      :disabled="disabled"
      :size="size"
      :placeholder="placeholder"
      :active-color="onColor"
      :inactive-color="offColor"
      :active-text="isDesktop ? onText : null"
      :inactive-text="isDesktop ? offText : null"
      :active-close-icon="onIcon"
      :inactive-close-icon="offIcon"
      @change="updated">
    </el-switch>
  </component>
</template>

<script>

export default {
  name: 'switch-input',


  props: {

    label: {
      type: String,
      default: null
    },

    value: {
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: 'default'
    },

    onText: {
      type: String,
      default: 'Yes'
    },

    offText: {
      type: String,
      default: 'No'
    },

    onIcon: {
      type: String,
      default: 'fa fa-check-circle'
    },

    offIcon: {
      type: String,
      default: 'fa fa-times-circle'
    },

    onColor: {
      type: String,
      default: '#67C23A'
    },

    offColor: {
      type: String,
      default: '#F56C6C'
    },

    placeholder: {
      type: String,
      default: null
    },

    helpText: {
      type: String,
      default: null
    },

    prop: {
      type: String,
      default: null
    },

    noForm: {
      type: Boolean,
      default: false
    }

  },



  methods: {

    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }

  },



  watch: {
    value: function (val) {
      this.formData = val
    }
  },


  data () {

    return {
      formData: this.value,
      el: this.noForm ? 'div' : 'el-form-item'
    }

  }

}
</script>
